import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Helpers } from '../helpers';
import { IPortalConfig, IPortalNavigation, IUserPortalFeatures, PlatForm } from '../models';
import { CoreService, LoaderService, PortalService, SecurityService } from '../services';
import { AuthorizationService } from '../services/authorization.service';
import { Constants } from '../shared/models/constants';

@Injectable({ providedIn: 'root' })
export class PotalFeatureAuthorizeGuard  {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(res => {
      
      let sponsorName: string = route.parent?.parent?.paramMap.get('Sponsor') == null ? <string>route.parent?.paramMap.get('Sponsor') : <string>route.parent?.parent?.paramMap.get('Sponsor');
      let portalName: string = route.parent?.parent?.paramMap.get('Portal') == null ? <string>route.parent?.paramMap.get('Portal') : <string>route.parent?.parent?.paramMap.get('Portal');
      //let featureName = <string>route.routeConfig?.path?.toLowerCase() == "" ? "myview" : <string>route.routeConfig?.path?.toLowerCase(); // When use path
      let featureName = route.url.length == 0 ? "myview" : <string>route.url[0].path.toLowerCase() == "" ? "myview"
        : <string>route.url[0].path.toLowerCase() == Constants.RASPberryAI_HOME_ROUTE.toLowerCase() ? Constants.RASPberryAI_FEATURE_NAME.toLowerCase()
        : <string>route.url[0].path.toLowerCase() == 'patientformquestionnaire' ? "forms"
          : <string>route.url[0].path.toLowerCase() == 'survey' ? "formcenter"
            : <string>route.url[0].path.toLowerCase() == 'surveypreview' ? "preview"
            : <string>route.url[0].path.toLowerCase() == 'mylog' ? "mylog"
              : (<string>route.url[0].path.toLowerCase() == 'emailcampaigns' || <string>route.url[0].path.toLowerCase() == 'emailcampaignreport' || <string>route.url[0].path.toLowerCase() == 'emailcampaingn') ? "emailcampaign"
                : <string>route.url[0].path.toLowerCase() == 'patientformquestionnairepreview' ? "preview"
                  : <string>route.url[0].path.toLowerCase(); // When use matcher
      if(Helpers.getPlatformId() == PlatForm.StudyStat && featureName == "studydocuments"){
        res(true);
      } else {
        if (featureName == "myview" || featureName == "preview" ||  featureName == "mylog") {
          res(true);
        } else {
          if (this.authorizationService.isNavigationOrFeatueAllowed(featureName))
            res(true);
          else {
            this.router.navigateByUrl(`/Go/${sponsorName}/${portalName}/NoAccess`);
            res(false);
          }
        }
      }
    });
  }
}

@Injectable({ providedIn: 'root' })
export class ReportFeatureAuthorizeGuard  {
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private authorizationService: AuthorizationService,
    private securityService: SecurityService,
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    this.loaderService.showLoader();
    return new Promise(res => {
      let currentUser = this.securityService.currentUserValue;
      let sponsorName: string = <string>route.parent?.paramMap.get('Sponsor');
      let portalName: string = <string>route.parent?.paramMap.get('Portal');

      let reportId = route.queryParams["rpt"];
      if (reportId == undefined || Number.isNaN(reportId)) {
        this.router.navigateByUrl(`/Report/${sponsorName}/${portalName}/NotFound`);
        res(false);
      } else {
        let IsMedPointReport = route.queryParams["reports"] != undefined ? route.queryParams["reports"] == "medpt" ? true : false : false;
        if (IsMedPointReport) {
          if (Helpers.isMedPointUser(currentUser.UserName)) {
            res(true);
          } else {
            this.router.navigateByUrl(`/Report/${sponsorName}/${portalName}/NoAccess`);
            res(false);
          }
        } else {
          let feature = this.authorizationService.getFeatueByFeatureId(route.queryParams["rpt"]);
          if (feature.length > 0) {
            res(true);
          } else {
            this.router.navigateByUrl(`/Report/${sponsorName}/${portalName}/NoAccess`);
            res(false);
          }
        }
      }
    });
  }
}

@Injectable({ providedIn: 'root' })
export class IsMedPointUserAuthorizeGuard  {
  constructor(
    private router: Router,
    private coreService: CoreService,
    private authorizationService: AuthorizationService,
    private securityService: SecurityService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(res => {
      let sponsorName: string = <string>route.parent?.parent?.paramMap.get('Sponsor');
      let portalName: string = <string>route.parent?.parent?.paramMap.get('Portal');
      let currentUser = this.securityService.currentUserValue;

      if (Helpers.isMedPointUser(currentUser.UserName)) {
        res(true);
      }
      else {
        this.router.navigateByUrl(`/Go/${sponsorName}/${portalName}/NoAccess`);
        res(false);
      }
    });
  }
}

@Injectable({ providedIn: 'root' })
export class ResetPotalFeatureAuthorizeGuard  {
  constructor(
    private router: Router,
    private portalService: PortalService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(res => {
      let portalconfig: IPortalConfig = { };
      this.portalService.setPortalConfigSubject(portalconfig);
      res(true);
    });
  }
}
